import CircleQuestionMarkFilled from '../../src/legacy/CircleQuestionMarkFilled';
export default CircleQuestionMarkFilled;
